import { ThemeOptions } from '@mui/material';

import robotoLightWoff from '../fonts/hinted-subset-Roboto-Light.woff';
import robotoLightWoff2 from '../fonts/hinted-subset-Roboto-Light.woff2';
import robotoRegularWoff from '../fonts/hinted-subset-Roboto-Regular.woff';
import robotoRegularWoff2 from '../fonts/hinted-subset-Roboto-Regular.woff2';
import robotoMediumWoff from '../fonts/hinted-subset-Roboto-Medium.woff';
import robotoMediumWoff2 from '../fonts/hinted-subset-Roboto-Medium.woff2';
import robotoBoldWoff from '../fonts/hinted-subset-Roboto-Bold.woff';
import robotoBoldWoff2 from '../fonts/hinted-subset-Roboto-Bold.woff2';
import ubuntuMono from '../fonts/hinted-subset-UbuntuMono-Regular.woff';


export const fontsOptions: ThemeOptions = {
    typography: {
        fontFamily: 'Roboto',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                    font-weight: 300;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-display: swap;
                    src: local(''),
                        url(${robotoLightWoff2}) format('woff2'),
                        url(${robotoLightWoff}) format('woff');
                }

                @font-face {
                    font-weight: normal;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-display: swap;
                    src: local(''),
                        url(${robotoRegularWoff2}) format('woff2'),
                        url(${robotoRegularWoff}) format('woff');
                }

                @font-face {
                    font-weight: 500;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-display: swap;
                    src: local(''),
                        url(${robotoMediumWoff2}) format('woff2'),
                        url(${robotoMediumWoff}) format('woff');
                }

                @font-face {
                    font-weight: bold;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-display: swap;
                    src: local(''),
                        url(${robotoBoldWoff2}) format('woff2'),
                        url(${robotoBoldWoff}) format('woff');
                }

                @font-face {
                    font-weight: normal;
                    font-family: 'Ubuntu Mono';
                    font-style: normal;
                    font-display: swap;
                    src: url(${ubuntuMono}) format('woff');
                }
            `,
        },
    },
};
